import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

class Id {
  private constructor() {}
  public static readonly prefix =
    'UI.scripts.dealer-franchisee.purchase-orders.views.FranchiseePurchaseOrderDetailView.';
  public static readonly pleaseAddPurchaseOrderTitle = `${Id.prefix}pleaseAddPurchaseOrderTitle`;
  public static readonly franchiseeOrderNo = `${Id.prefix}franchiseeOrderNo`;
  public static readonly dealerOrderNo = `${Id.prefix}dealerOrderNo`;
  public static readonly title = `${Id.prefix}title`;
  public static readonly description = `${Id.prefix}description`;
  public static readonly proposedInstallationDate = `${Id.prefix}proposedInstallationDate`;
  public static readonly author = `${Id.prefix}author`;
  public static readonly supplierReference = `${Id.prefix}supplierReference`;
  public static readonly supplierProgressStatus = `${Id.prefix}supplierProgressStatus`;
  public static readonly supplierDeliveryDate = `${Id.prefix}supplierDeliveryDate`;
  public static readonly supplierClosedDate = `${Id.prefix}supplierClosedDate`;
  public static readonly supplierShippingLead = `${Id.prefix}supplierShippingLead`;
  public static readonly purchaseOrderItems = `${Id.prefix}purchaseOrderItems`;
  public static readonly net = `${Id.prefix}net`;
  public static readonly downloadReport = `${Id.prefix}downloadReport`;
}

export class LangFranchiseePurchaseOrderDetailView {
  private constructor() {}
  public static pleaseAddPurchaseOrderTitle(): string {
    return interpolate(Id.pleaseAddPurchaseOrderTitle);
  }
  public static franchiseeOrderNo(): string {
    return interpolate(Id.franchiseeOrderNo);
  }
  public static dealerOrderNo(params: { dealerName: string }): string {
    return interpolate(Id.dealerOrderNo, params);
  }
  public static title(): string {
    return interpolate(Id.title);
  }
  public static description(): string {
    return interpolate(Id.description);
  }
  public static proposedInstallationDate(): string {
    return interpolate(Id.proposedInstallationDate);
  }
  public static author(): string {
    return interpolate(Id.author);
  }
  public static supplierReference(params: { supplierName: string }): string {
    return interpolate(Id.supplierReference, params);
  }
  public static supplierProgressStatus(params: { supplierName: string }): string {
    return interpolate(Id.supplierProgressStatus, params);
  }
  public static supplierDeliveryDate(params: { supplierName: string }): string {
    return interpolate(Id.supplierDeliveryDate, params);
  }
  public static supplierClosedDate(params: { supplierName: string }): string {
    return interpolate(Id.supplierClosedDate, params);
  }
  public static supplierShippingLead(params: { supplierName: string }): string {
    return interpolate(Id.supplierShippingLead, params);
  }
  public static purchaseOrderItems(): string {
    return interpolate(Id.purchaseOrderItems);
  }
  public static net(): string {
    return interpolate(Id.net);
  }
  public static downloadReport(): string {
    return interpolate(Id.downloadReport);
  }
}

export class FranchiseePurchaseOrderDetailViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.pleaseAddPurchaseOrderTitle,
      "Please add a {{glossary 'purchase-order'}} Title",
      'Validation: add purchase order title'
    );
    register.add(Id.franchiseeOrderNo, "{{glossary 'franchisee'}} Order No.", 'Label: franchisee order number');
    register.add(Id.dealerOrderNo, '{{dealerName}} Order No.', 'Label: dealer order number');
    register.add(Id.title, 'Title', 'Label: title');
    register.add(Id.description, 'Description', 'Label: description');
    register.add(Id.proposedInstallationDate, 'Proposed Installation Date', 'Label: proposed installation date');
    register.add(Id.author, 'Author', 'Label: author');
    register.add(Id.supplierReference, '{{supplierName}} Reference', 'Label: supplier reference');
    register.add(Id.supplierProgressStatus, '{{supplierName}} Progress Status', 'Label: supplier progress status');
    register.add(Id.supplierDeliveryDate, '{{supplierName}} Delivery Date', 'Label: supplier delivery date');
    register.add(Id.supplierClosedDate, '{{supplierName}} Closed Date', 'Label: supplier closed date');
    register.add(Id.supplierShippingLead, '{{supplierName}} Shipping Lead', 'Label: supplier shipping lead');
    register.add(Id.purchaseOrderItems, "{{glossary 'purchase-order'}} Items", 'Section header: purchase order items');
    register.add(Id.net, 'Net', 'Label: net');
    register.add(Id.downloadReport, 'Download Report', 'Button label for downloading the purchase order report');
  }
}
